// extracted by mini-css-extract-plugin
export var flexColumn = "legals-module--flexColumn--LlJhS";
export var flexRow = "legals-module--flexRow---ZWQm";
export var logoWrapper = "legals-module--logoWrapper--KXSxX";
export var margin = "legals-module--margin--5Lt7J";
export var wrapper = "legals-module--wrapper--6PYmW";